import { documentLibraryControllerAddPersonsToDocumentsMutation } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import { BulkDocumentLibraryFiltersDto } from '@dealstack/shared/lib/backendClient';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { withMidnightUtcDateRange } from './documentLibraryFilters.utils';

interface AddPersonsToDocumentsVariables {
	dealId: string;
	allDocumentsSelected: boolean;
	documentIds: string[];
	personIds: string[];
	filters?: BulkDocumentLibraryFiltersDto;
}

export const useAddPersonsToDocuments = () => {
	const queryClient = useQueryClient();

	const mutation = useMutation({
		...documentLibraryControllerAddPersonsToDocumentsMutation(),
		// Reload the documents table so the updated "related persons" reflect
		// immediately. Prefix key match refetches every filter variant.
		onSuccess: (_data, { path }) =>
			queryClient.refetchQueries({
				queryKey: [
					formatUnicorn(API_PATHS.DEAL_DEALID_DOCUMENT_LIBRARY_DOCUMENTS_GET, {
						dealId: path.dealId,
					}),
				],
			}),
	});

	return {
		mutateAsync: (
			{
				dealId,
				allDocumentsSelected,
				documentIds,
				personIds,
				filters,
			}: AddPersonsToDocumentsVariables,
			options?: Parameters<typeof mutation.mutateAsync>[1]
		) => {
			const excludedDocumentIds = allDocumentsSelected ? documentIds : undefined;
			const selectedDocumentIds = allDocumentsSelected ? undefined : documentIds;

			return mutation.mutateAsync(
				{
					path: { dealId },
					body: {
						personIds,
						allDocumentsSelected,
						excludedDocumentIds,
						selectedDocumentIds,
						filters: withMidnightUtcDateRange(filters),
					},
				},
				options
			);
		},
		isPending: mutation.isPending,
	};
};
